import "./style.less";

const COUNT = 12;

export default function SnowFlakes() {
	/* eslint-disable react/no-array-index-key */
	return <div className="snowflakes" aria-hidden="true">
		{ Array.from({ length: COUNT }).map((item, ind) => <div className="snowflake" key={ind}>
			<div className="inner">❅</div>
		</div>)}
	</div>;
}
